import {
  attributeDefinitionIdFormat,
  imageIdFormat,
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import { AttributeSchema } from "@redotech/redo-model/inventory/attributes";
import { ShopifyProductFieldType } from "@redotech/redo-prisma-client/enums";
import * as z from "zod/v4";

const ImageSchema_ = z.object({
  id: imageIdFormat.schema,
  url: z.string(),
  alt_text: z.string(),
  position: z.number(),
});

const ProductInFamilySchema_ = z.object({
  id: productIdFormat.schema,
  title: z.string(),
  upc: z.string().nullish(),
  sku: z.string().nullish(),
  price: z.number().nullish(),
  currency: z.string().nullish(),
  image: ImageSchema_.nullish(),
  availableInventory: z.number(),
  options: z.array(
    z.object({
      name: z.string(),
      value: z.string(),
    }),
  ),
});

const ProductOptionsSchema_ = z.object({
  name: z.string(),
  options: z.array(z.string()),
});

export const ProductOptionsSchema: z.ZodType<ProductOptions> =
  ProductOptionsSchema_;
export interface ProductOptions extends z.infer<typeof ProductOptionsSchema_> {}

const ProductFamilyDetailsSchema_ = z.object({
  id: productFamilyIdFormat.schema,
  title: z.string(),
  description: z.string(),
  vendor: z.string().nullable(),
  tags: z.array(z.string()),
  created_at: z.date(),
  updated_at: z.date(),
  images: z.array(ImageSchema_),
  products: z.array(ProductInFamilySchema_),
  attributes: z.array(AttributeSchema),
  options: z.array(ProductOptionsSchema_),
});

export const ProductFamilyDetailsSchema: z.ZodType<ProductFamilyDetails> =
  ProductFamilyDetailsSchema_;
export interface ProductFamilyDetails
  extends z.infer<typeof ProductFamilyDetailsSchema_> {}

export const getProductFamilyDetails = {
  name: "getProductFamilyDetails" as const,
  input: z.object({ productFamilyId: productFamilyIdFormat.schema }),
  output: z.object({
    productFamily: ProductFamilyDetailsSchema.nullable(),
    shopifyMappings: z.array(
      z.object({
        fieldName: z.enum(ShopifyProductFieldType),
        attributeDefinitionId: attributeDefinitionIdFormat.schema,
      }),
    ),
  }),
};
